import { useState } from "react";
import { Button, Drawer } from "antd";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Link } from "react-router-dom";

const Responsive = ({handleMenu}) => {
  
  const [searchClass, setSearchClass] = useState("");
  const [searched, setSearched] = useState(false);
  const [isOpen, setIsOpen ] = useState(true);
  const [toggle, setToggle] = useState(false);
  const [domestictoggle, setDomesticToggle] = useState(false);
  const [internationaltoggle, setInternationalToggle] = useState(false);
  const [expresstoggle, setExpressToggle] = useState(false);
  const [logisticstoggle, setLogisticsToggle] = useState(false);

  // const [expand, setExpand] = useState(false); 

  const closeDropFunction = (id) => {
    document.getElementById(id).style.display = 'block'
    document.getElementById(id).style.opacity = 0
  }
  const openDropFunction = (id) => {
    document.getElementById(id).style.display = 'block'
    document.getElementById(id).style.opacity = 1
  }


  const handleSearch = () => {
    setSearchClass("");
    setSearched(true);
  };

  const closeSearch = () => {
    setSearched(false);
    setSearchClass("placeholder-close");
  };
  return (
    <>
      

     
      <div className="h-[auto] bg-[#F21E26] mt-[2.1rem] xl:hidden lg:hidden">
        <ul className="list-group pt-[1.2rem] text-[white] bg-[#F21E26] xl:hidden lg:hidden  "  onClick={() => setToggle(!toggle)}>
          <div className=" flex justify-between">
          
            <Link to="/about" className="pointer-cursor" onClick={handleMenu}>About Us</Link>
            <i className={` ${!toggle ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}`} onClick={() => setToggle(!toggle)} ></i>
        
            {/* </li> */}

          </div>
        
          {toggle && (
         <div>
            

          <div className="summary-chevron-up responsive-arrow-up ">
            <hr className="header-hr mx-[.1rem] mt-[1rem]" />
            <li id="aboutDrop" onClick={handleMenu}>
              <Link
              
                to="/about/mission"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Mission and Core Values
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li id="aboutDrop" onClick={handleMenu}>
              <Link
              
                to="/leadership"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Leadership
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                id="aboutDrop"
                to="about/mile-stone"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Milestones
              </Link>
            </li>
          </div>
          
          </div>
          )}
        </ul>
        <ul className="list-group pt-[2.5rem] text-[white] bg-[#F21E26] xl:hidden lg:hidden  "  onClick={() => setDomesticToggle(!domestictoggle)}>
          <div className=" flex justify-between">
          
        <Link to="/domestic" className="cursor-pointer" onClick={handleMenu}>Domestic</Link>
        <i className={` ${!domestictoggle ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}`} onClick={() => setDomesticToggle(!domestictoggle)} ></i>
        
        {/* </li> */}

        </div>
        
        {domestictoggle && (
         <div>
            

            <div className="summary-chevron-up responsive-arrow-up ">
            <hr className="header-hr mx-[.1rem] mt-[1rem]" />
            <li id="domesticDrop" onClick={handleMenu}>
            <Link
                to="/domestic/overnight"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Overnight Express
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/samedaydelivery"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Same Day Delivery
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/2nddaydelivery"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                2nd Day Delivery
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/timechoicedelivery"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Time Choice Delivery
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/redbox"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                RedBox
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/economyexpress"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Economy Express
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/expressflyer"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Express Flyer
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/mehfoozexpress"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Mehfooz Express
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/liquidshipping"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Liquid Shipments
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/studentexpress"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Student Express
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/attestationservices"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Attestation Service
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/ticketingservices"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Ticketing Services
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/codandcodplus"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                COD & COD+
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/paymentsolution"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Payment Solution
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/shipmentinsurance"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                CVI—Shipment Insurance
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/tcsfresh"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                TCS Fresh
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/ecomsolution"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                E-com Solutions
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/mms"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                MMS
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/overlandexpress"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Overland Express
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/Warehousing"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Warehousing
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/distribution"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Distribution
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/pack-n-go"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                PackNGo
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic/coldchain"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Cold Chain Management
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
           
            
          </div>
          
          </div>
          )}
        </ul>
      
        <ul className="list-group mt-[2.5rem] text-[white] bg-[#F21E26] xl:hidden lg:hidden  "  onClick={() => setInternationalToggle(!internationaltoggle)}>
          <div className=" flex justify-between">
          
        <Link to="/international" onClick={handleMenu}>International</Link>
        <i className={` ${!internationaltoggle ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}`} onClick={() => setInternationalToggle(!internationaltoggle)} ></i>
        
        {/* </li> */}

        </div>
        
        {internationaltoggle && (
         <div>
            

            <div className="summary-chevron-up responsive-arrow-up ">
            <hr className="header-hr mx-[.1rem] mt-[1rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/international/redbox"
                className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
              >
                RedBox
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/international/expressflyer"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Express Flyer
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/international/uspasswordrenewal"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                US Passport Renewal
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/international/studentexpress"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Students Express
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/international/visatronix"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Visatronix
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/international/internationalfreight"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                International Freight
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/international/custombrokrage"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Customs Brokerage
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/international/regional-trucking"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Regional Trade / TIR
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
          </div>
          
          </div>
          )}
        </ul>

        <ul className="list-group pt-[2.5rem] text-[white] bg-[#F21E26] xl:hidden lg:hidden  "  onClick={() => setExpressToggle(!expresstoggle)}>
          <div className=" flex justify-between">
          
        <Link to="/tcsexpress" onClick={handleMenu}>Express</Link>
        <i className={` ${!expresstoggle ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}`} onClick={() => setExpressToggle(!expresstoggle)} ></i>
        
        {/* </li> */}

        </div>
        
        {expresstoggle && (
         <div>
            

            <div className="summary-chevron-up responsive-arrow-up ">
            <hr className="header-hr mx-[.1rem] mt-[1rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/domestic-express"
                className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
              >
                Domestic Express
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/international-express"
                className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
              >
                International Express
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/aviation"
                className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
              >
                Aviation
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/financial-services"
                className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
              >
                Financial Services
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/ecom-solution"
                className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
              >
                E-com Solutions
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/intiana-travel"
                className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
              >
                Travel & Tours
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/visatronix"
                className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
              >
                Visatronix
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/mms"
                className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
              >
                MMS
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
          </div>
          
          </div>
          )}
        </ul>

        <ul className="list-group pt-[2.5rem] text-[white] bg-[#F21E26] xl:hidden lg:hidden  "  onClick={() => setLogisticsToggle(!logisticstoggle)}>
          <div className=" flex justify-between">
          
        <Link to="/tcslogistics" onClick={handleMenu}>Logistics</Link>
        <i className={` ${!logisticstoggle ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}`} onClick={() => setLogisticsToggle(!logisticstoggle)} ></i>
        
        {/* </li> */}

        </div>
        
        {logisticstoggle && (
         <div>
            

            <div className="summary-chevron-up responsive-arrow-up ">
            <hr className="header-hr mx-[.1rem] mt-[1rem]" />
            
            <li onClick={handleMenu}>
              <Link
                to="/overland-logistics"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Overland Express
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/fleet-transportation"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Fleet & Transportation
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/warehousing"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Warehousing
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/distribution"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Distribution
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/international-freights"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                International Freight
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/customs-bokerage"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Customs Brokerage
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/pack-n-go"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                PackNGo
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/expo-logistics"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Expo Logistics
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/project-logistics"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Project Logistics
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/coldchain"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Cold Chain Management
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/agri-logistics"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Agri Logistics
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            <li onClick={handleMenu}>
              <Link
                to="/regional-trade"
                className="py-[0.3rem] px-3 hover:bg-[#CC1219] block"
              >
                Regional Trade / TIR
              </Link>
            </li>
            <hr className="header-hr mx-[.8rem]" />
            
          </div>
          
          </div>
          )}
        </ul>

        <ul className=" lg:flex gap-3 items-center md:grid md:mx-auto md:justify-left lg:hidden flex sm:pt-[2rem] pt-[2.5rem] pb-[1rem]">
        <li className="cursor-pointer relative nav" onClick={handleMenu}>
                <Link to="/ecom-solution">
                  <div className="flex items-center">E-com Solutions</div>
                </Link>
              </li>
        </ul>
        <ul className=" lg:flex gap-3 items-center md:grid md:mx-auto md:justify-left lg:hidden flex sm:pt-[2rem] pt-[2rem] pb-[1rem]">
          <li className="cursor-pointer relative nav" onClick={handleMenu}>
              <Link to="/customer-services">
                <div className="flex items-center">Contact Us</div>
              </Link>
          </li>
        </ul>

               

      <div
        className={`sentiment  xl:hidden lg:hidden md:grid grid mb-1 self-end ${
          searched ? "gap-[0rem]" : "gap-6"
        } sm:pt-2 pt-5 pb-[1rem]`}
      >
        <a target="_blank" href="https://sentimentsexpress.com/">
          <img src="/brands/sentiments.svg" className="w-[4rem]" />
        </a>
        <a target="_blank" href="https://www.studiobytcs.com/">
          <img
            src="/brands/studio.svg"
            className="w-[3.5rem] pt-[.5rem] mr-[3.1rem]"
          />
        </a>
        
                <Link to="/customer-portals" className="pt-[.5rem]">
                  <button className="bg-[#CC1219] lg:w-[8rem] w-[8rem] h-7 rounded-sm cursor-pointer transition-all duration-500 gradientbg">
                    MY TCS
                  </button>
                </Link>
              
        {/* <div className= {` nav cursor-pointer ${searched && "mr-[-0.41rem]"} `}>
                            Pakistan 
                            <KeyboardArrowDownIcon />
                            <div className="absolute dropdown">
                           
                               
                                <div className="w-[17rem] h-12 absolute"></div>
                                <div className="py-3 shadow-md bg-white text-[#373737] text-xs w-[4.8rem] rounded-b-sm mt-1 relative z-10 top-[0.25rem]">
                                    <ul className="">
                                        <li className="py-[0.3rem] px-3  hover:bg-[#e1e1e1]">
                                           <a href="https://uae.tcsexpress.com/" target="_blank">UAE</a> 
                                            </li>
                                        <li className="py-[0.3rem] px-3  hover:bg-[#e1e1e1]">
                                           <a href="https://tcsexpress.co.uk/" target="_blank"> UK</a>
                                            </li>
                                    </ul>
                                </div>
                            </div>
                        </div> */}
      </div>
      </div>
    </>
  );
};
export default Responsive;
